const HTML_ESCAPE_MAP = Object.freeze({
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
})

export function escapeHTML(value) {
  if (value === null || value === undefined) return ""

  return String(value).replace(/[&<>"']/g, character => HTML_ESCAPE_MAP[character])
}

export function truncateAndEscapeHTML(value, maximumLength) {
  const text = value === null || value === undefined ? "" : String(value)
  const truncated = text.length > maximumLength ? `${text.substring(0, maximumLength)}...` : text

  return escapeHTML(truncated)
}

function escapeIngredientsDisplayData(data) {
  if (!Array.isArray(data)) return []

  return data.map(component => ({
    ...component,
    component: escapeHTML(component?.component),
    categories: Array.isArray(component?.categories) ? component.categories.map(category => ({
      ...category,
      category: escapeHTML(category?.category),
      ingredients: Array.isArray(category?.ingredients) ? category.ingredients.map(ingredient => ({
        ...ingredient,
        name: escapeHTML(ingredient?.name)
      })) : []
    })) : []
  }))
}

function escapeIdentity(record, fields) {
  if (!record) return record

  return fields.reduce(
    (safeRecord, field) => ({ ...safeRecord, [field]: escapeHTML(record[field]) }),
    { ...record }
  )
}

export function escapeStationOrderForHTML(order) {
  const source = order || {}

  return {
    ...source,
    order_number: escapeHTML(source.order_number),
    store: escapeIdentity(source.store, ["name"]),
    account: escapeIdentity(source.account, ["name", "last_name"]),
    order_items: Array.isArray(source.order_items) ? source.order_items.map(item => ({
      ...item,
      product: item?.product ? {
        ...item.product,
        // La descripción se trunca antes de escapar en formatOrderHTML para
        // conservar el límite visible de 50 caracteres del render anterior.
        name: escapeHTML(item.product.name)
      } : item?.product,
      ingredients_display_data: escapeIngredientsDisplayData(item?.ingredients_display_data)
    })) : []
  }
}

export function escapePickupOrderForHTML(order) {
  const source = order || {}

  return {
    ...source,
    order_number: escapeHTML(source.order_number),
    client_name: escapeHTML(source.client_name),
    client_last_name: escapeHTML(source.client_last_name),
    paid_at: escapeHTML(source.paid_at),
    order_items: Array.isArray(source.order_items) ? source.order_items.map(item => ({
      ...item,
      product_name: escapeHTML(item?.product_name),
      ingredients: escapeIngredientsDisplayData(item?.ingredients)
    })) : []
  }
}
